import styled from 'styled-components';

export const Container = styled.div``;

export const ListWrapper = styled.div<{ $editMode?: boolean }>`
  width: 100%;
  border-radius: ${({ theme }) => theme.card.borderRadius}px;
  border: 1px solid ${({ theme }) => theme.colors.downloads.border};

  ${({ $editMode }) =>
    $editMode &&
    `
    padding: 25px;
  `}
`;
